import { useEffect } from 'react'
import gsap from 'gsap'
import works from './works'
import experiments from './experiments'
import Work from './Work'
import Intro from './Intro'
import './style.scss'

const App = () => {
  useEffect(() => {
    gsap.to('section', {
      opacity: 1,
      delay: 3,
      ease: 'power3.out',
      duration: 2
    })
  }, [])

  const renderWorks = () => {
    return (
      <section>
        <h2>Selected Works</h2>
        <p>A selection of projects from 2022 to 2024 in which I collaborate as fullstack/creative developer.</p>
        <div className="works">
          {works.map((work, i) => (
            <div className="work" key={i.toString()}>
              <Work image={work.image} link={work.link} name={work.name} />
            </div>
          ))}
        </div>
      </section>
    )
  }

  const renderExperiments = () => {
    return (
      <section>
        <h2>Selected Experiments</h2>
        <p>Some of my experiments from 2019 to 2024 which include glsl, svg, canvas, threejs and react.</p>
        <div className="experiments">
          {experiments.map((exp, i) => {
            const num = i + 1 < 10 ? `0${i + 1}` : i + 1
            return (
              <div className="experiment" key={i.toString()}>
                <Work image={exp.image} link={exp.link} name={`<em>${num}</em> ${exp.name}`} />
              </div>
            )
          })}
        </div>
      </section>
    )
  }


  const renderTalks = () => {
    return (
      <section>
        <h2>Talks</h2>
        <div className="cv-work">
          <div className="years">Deadline Festival - june 2024</div>
          <h3>
            <a href="https://deadline.talentgarden.com/" target="_blank">Advanced opportunities.</a>
          </h3>
          <div style={{marginTop: '.2em'}}>Creating immersive web experiences and sensational digital assets using video, 3D objects, and live rendering to enhance luxury brand communications.</div>
        </div>
      </section>
    )
  }

  const renderPublications = () => {
    return (
      <section>
        <h2>Publications</h2>
        <div className="cv-work">
          <div className="years">Codrops Tutorial - apr 2023</div>
          <h3>
            <a href="https://tympanus.net/codrops/2023/04/27/building-a-webgl-carousel-with-react-three-fiber-and-gsap/" target="_blank">Building a WebGL Carousel with React Three Fiber and GSAP</a>
          </h3>
        </div>
        <div className="cv-work">
          <div className="years">Awwwards Course - feb 2021</div>
          <h3>
            <a href="https://www.awwwards.com/academy/course/impress-everyone-with-a-3d-particle-scene-starting-from-bad-models" target="_blank">Impress everyone with a 3D particle scene with Blender and Three.js</a>
          </h3>
        </div>
      </section>
    )
  }

  const renderCV = () => {
    return (
      <section>
        <h2>Experience</h2>
        <div className="cv-work">
          <div className="years">nov 2018 - now</div>
          <h3>
            Fullstack &amp; Creative Developer @{' '}
            <a href="https://www.studiogusto.com/" target="_blank">
              Studiogusto
            </a>
          </h3>
        </div>
        <div className="cv-work">
          <div className="years">jan 2022 - june 2022</div>
          <h3>
            Teacher - Webgl &amp; Creative Development @{' '}
            <a href="https://www.nuovoistitutodesign.it/" target="_blank">
              NID - Nuovo Istituto Design
            </a>
          </h3>
        </div>
        <div className="cv-work">
          <div className="years">oct 2021 - dec 2021</div>
          <h3>
            Senior Creative Developer @{' '}
            <a href="https://www.akqa.com/" target="_blank">
              AKQA
            </a>
          </h3>
        </div>
        <div className="cv-work">
          <div className="years">feb 2021</div>
          <h3>
            Teacher @{' '}
            <a href="https://www.awwwards.com/academy/course/impress-everyone-with-a-3d-particle-scene-starting-from-bad-models" target="_blank">
              Awwwards Academy
            </a>
          </h3>
        </div>
        <div className="cv-work">
          <div className="years">feb 2005 - oct 2018</div>
          <h3>
            Web Designer &amp; Developer @{' '}
            <a href="https://www.websolute.com/" target="_blank">
              Websolute
            </a>
          </h3>
        </div>
        <div className="cv-work">
          <div className="years">gen 2002 - feb 2005</div>
          <h3>Freelance Web Designer &amp; Developer</h3>
        </div>
      </section>
    )
  }

  const renderAwards = () => {
    return (
      <section>
        <h2>Awards</h2>
        <ul>
          <li> 1x FWAWWWARDS</li>
          <li> 9x Awwwards</li>
          <li> 11x FWA</li>
          <li> 11x CSSDA</li>
          <li> 16x DDA</li>
          <li> 8x IKA</li>
          <li> 11x WebAward</li>
        </ul>
      </section>
    )
  }

  const renderContacts = () => {
    return (
      <section>
        <h2>Contacts</h2>
        <ul class="no-border">
          <li>
            <Work link="mailto:fabio.ottaviani@gmail.com" name="Email: fabio.ottaviani@gmail.com" />
          </li>
          {/* <li>
            <Work link="tel:+393490664806" name="Mobile Phone: +39 349 0664806" />
          </li> */}
          <li>
            <Work link="https://www.linkedin.com/in/fabio-ottaviani-82b0776/" name="Linkedin" />
          </li>
          <li>
            <Work link="https://instagram.com/supahfunk" name="Instagram" />
          </li>
          <li>
            <Work link="https://twitter.com/supahfunk" name="Twitter" />
          </li>
          <li>
            <Work link="https://dribbble.com/supahfunk" name="Dribbble" />
          </li>
          <li>
            <Work link="https://codepen.io/supah" name="Codepen" />
          </li>
          <li>
            <Work link="https://www.shadertoy.com/user/supah" name="Shadertoy" />
          </li>
        </ul>
      </section>
    )
  }

  return (
    <div>
      <Intro />
      {renderCV()}
      {renderWorks()}
      {renderExperiments()}
      {renderPublications()}
      {renderTalks()}
      {renderAwards()}
      {renderContacts()}
      <br />
      <br />
      <br />
      <section className="goodbye">Thank you 👋</section>
    </div>
  )
}

export default App
